/**
 * FlatSplitButton.js
 * Flat split button with dropdown
 *
 * @class FlatSplitButton
 * @author  Yevgeniy Rokhlin
 */

import React from 'react';
import ClassNames from 'classnames';
import Menu from 'components/menu/Menu';
import FlatButton from 'components/buttons/flat-button/FlatButton';
import ClickAway from 'mixins/js/ClickAway';
import DropDownIcon from 'components/svg-icons/drop-down-arrow';
import Container from 'components/flexbox/Container';
import Block from 'components/flexbox/Block';


export default React.createClass({
	
	mixins: [ ClickAway ],

	manuallyBindClickAway: true,

	displayName: "FlatSplitButton",

	propTypes: {
		autoWidth: React.PropTypes.bool,
		menuItems: React.PropTypes.array.isRequired,
		status: React.PropTypes.string,
		rounded: React.PropTypes.bool,
		label: function(props, propName, componentName) {
			if (!props.children && !props.label) {
				return new Error('Warning: Required prop `label` or `children` was not specified in `' + componentName + '`.')
			}
		},
	},

	getInitialState(){
		return {
			open: false,
			selectedIndex: this.props.selectedIndex || 0

		}
	},

	componentDidUpdate(){
		if (this.state.open) {
			this._bindClickAway();
		} else {
			this._unbindClickAway();
		}

	},


	getDefaultProps(){
		return {
			status: "primary",
			rounded: true,
			autoWidth: true
		}
	},
	componentClickAway(){
		this.setState({
			open: false
		});
	},
	render() {
		let { 
			children,
			label,
			status,
			disabled,
			rounded,
			autoWidth,
			menuItems,
			className } = this.props;

		let wrapperClass = ClassNames('lui-drop-down-menu', 'lui-flat-split-button-wrapper', `lui-is-${this.props.status}`, {
			'lui-open': this.state.open,
			'lui-is-rounded': rounded,
			'lui-is-disabled': disabled
		});

		let buttonClasses = ClassNames('lui-flat-split-button', className);   	

		let dropDownButtonClasses = ClassNames('lui-flat-split-drop-down-button');

		return (
			<div>
				<Container className={wrapperClass} flexDirection="row" justifyContent="center">
					<Block width={0.8}>
						<FlatButton 
							className={buttonClasses}
							label={label} 
							status={status} 
							onClick={this._handleClick}
							disabled={disabled} />				
					</Block>
					<Block width={0.2}>
						<FlatButton 
							className={dropDownButtonClasses}
							status={status} 
							onClick={this._handleClick}
							disabled={disabled} >

							<DropDownIcon key="dropdown" className="lui-menu-drop-down-icon" />
						</FlatButton>
						<Menu
							ref="menuItems"
							autoWidth={autoWidth}
							selectedIndex={this.state.selectedIndex}
							menuItems={menuItems}
							hideable={true}
							visible={this.state.open}
							status={status}
							onItemClick={this._onMenuItemClick} />
					</Block>
				</Container>
			</div>
		);
	},

	_handleClick(){
		this.setState({
			open: !this.state.open
		});
	},

	_onMenuItemClick: function(e, key, payload) {
		this.setState({
		  selectedIndex: key,
		  open: false
		});
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/flat-button/FlatSplitButton.js
 **/